import { AlertCircle, Loader2 } from "lucide-react";
import React from "react";
import styles from "./notice.module.scss";

export function ScriptJobNotice({
  tone,
  title,
  detail,
}: {
  tone: "loading" | "error";
  title: string;
  detail?: string;
}) {
  return (
    <div className={styles.notice}>
      {tone === "loading" ? (
        <Loader2 size={22} className="spin-animation" />
      ) : (
        <AlertCircle size={22} />
      )}
      <p className={styles.title}>{title}</p>
      {detail ? <p className={styles.detail}>{detail}</p> : null}
    </div>
  );
}
